<template>
  <v-btn
    small
    @click="confirmDeleteUser"
    icon
  >
    <v-icon
      dark
      color="grey darken-4"
      >mdi-delete</v-icon
    >
  </v-btn>
</template>

<script>
  import Vue from 'vue'
  import { SHOW_DELETE_USER_MODAL } from '@/appLogic/permissions/store/constants'

  export default Vue.extend({
    props: {},
    methods: {
      confirmDeleteUser() {
        this.params.context.componentParent.setUserToDelete(this.params.data)
        this.$store.dispatch(SHOW_DELETE_USER_MODAL)
      },
    },
  })
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// AgGridButtonRenderer.vue?2207495b